const baseURL = '/api/course';
import basicRequest from '@/js/basicRequest.js';

const handleFn = (data: any, parameters: any, fn: any) => {
    if (fn != undefined && typeof fn == 'function') {
        fn(data, parameters);
    }
};
export const courseApi = {
    getDirById(opt?: any) {
        opt = opt || {};
        var url = baseURL + '/dir/ls';
        basicRequest.request({
            url,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            urlParams: opt.urlParams,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    }
};
